// extracted by mini-css-extract-plugin
export default {"labelContainer":"FieldAmount_labelContainer__NnPCv"};